module.exports = __webpack_public_path__ + "img/q1.1c4b5eb8.png";